import PropTypes from 'prop-types';

import Content from './Content';

import { CtfRichTextTag } from '@/utils/constants';

function ListContent({ contents, style, entries }) {
  if (!contents?.length) return null;

  return contents.map(({ content }, index) => (
    <li key={index} className={`aaco-list-item pl-2.5 ${style.li}`}>
      {content?.length > 0 &&
        content.map((liContent, contentIndex) => {
          // LIST INSIDE LIST
          if (
            liContent?.nodeType === CtfRichTextTag.UL ||
            liContent?.nodeType === CtfRichTextTag.OL
          ) {
            return (
              <List
                contents={liContent?.content}
                key={contentIndex}
                entries={entries}
                nodeType={liContent?.nodeType}
                style={{
                  paragraph: style.paragraph,
                  list: {
                    ol: 'p-0',
                    li: 'p-0 mb-0',
                  },
                }}
              />
            );
          }
          // NORMAL CONTENT INSIDE LIST
          return (
            <Content
              entries={entries}
              contents={liContent?.content}
              key={contentIndex}
              nodeType={liContent?.nodeType}
              style={style.paragraph}
            />
          );
        })}
    </li>
  ));
}

export default function List({ nodeType, contents, style }) {
  if (nodeType === CtfRichTextTag.UL) {
    return (
      <ul
        role="list"
        className={`aaco-list aaco-list--unordered list-disc pl-5
 ${style.ul}`}
      >
        <ListContent contents={contents} style={style} />
      </ul>
    );
  }

  return (
    <ol
      role="list"
      className={`aaco-list aaco-list--ordered list-decimal ${style.ol}`}
    >
      <ListContent contents={contents} style={style} />
    </ol>
  );
}

List.propTypes = {
  contents: PropTypes.array,
  nodeType: PropTypes.string,
  style: PropTypes.shape({
    li: PropTypes.string,
    ul: PropTypes.string,
    ol: PropTypes.string,
    paragraph: PropTypes.shape({
      blockquoteFont: PropTypes.string,
      customFont: PropTypes.string,
    }),
  }),
};

List.defaultProps = {
  style: {},
};
